import { motion } from "framer-motion";

const easing = [0.16, 1, 0.3, 1];

// Masked line-by-line reveal for headings
export const RevealText = ({ lines, className = "", delay = 0, testid }) => (
  <span className={className} data-testid={testid}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: easing, delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: easing, delay }}
  >
    {children}
  </motion.div>
);
